export class Brand {
  constructor(
    public hash?: string,
    public name?: string,
    public imagePath?: string,
    public bwImagePath?: string
  ) { }

  clone() {
    return new Brand(
      this.hash,
      this.name,
      this.imagePath,
      this.bwImagePath
    );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/brand.ts